import { useQuery } from '@tanstack/react-query';

import { getBestDealsAisle } from 'api/jalapeno';

import useAccountQuery from './useAccountQuery';

export const BEST_DEALS_AISLE_QUERY_KEY = 'best-deals-aisle';

const useBestDealsAisleQuery = ({ queryProps } = {}) => {
    const { data: account } = useAccountQuery();
    const { chargeID } = account?.nextOrder ?? {};

    return useQuery({
        queryKey: [BEST_DEALS_AISLE_QUERY_KEY, chargeID],
        queryFn: async () => {
            const response = await getBestDealsAisle(chargeID);
            return response?.data;
        },
        enabled: !!chargeID,
        ...queryProps,
    });
};

export default useBestDealsAisleQuery;
